export class GeneralMail { 
    fromAddresses: string;
    toAddresses: string;
    cc?: string;
    bcc?: string;
    attachments?: string[] | undefined;
    subject?: string | undefined;
    content?: string;
   isMissingValues?: boolean;
   uploadedFiles?: any[];
}
export enum ControlView {
    hidden = 1,
    active = 2,
    disabled = 3
}
